<template>

    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">


        <!-- SIDEBAR -->
        <SidebarBody/>

        <div class="hp-main-layout" style="overflow-x: hidden;">

            <!-- HEADER -->
            <HeaderBody/>

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content " style="padding-left: 10px; padding-right: 10px;">

                <div class="row mb-32 gy-8 dash-top">

                    <!-- NOTI -->
                    <div class="col-12">

                        

                        <div class="row g-32 ">

                            <div class="dd-none">

                                <div style="width: 100%; display: flex; justify-content: center; align-items: center; margin-top: -10px; padding-left: 15px;">

                                    <i class="hp-text-color-dark-0 iconly-Light-Search" style="font-size: 16px; margin-right: -35px; color: #b2bec3;"></i>

                                    <input @input="clearSearch" type="text" class="form-control" placeholder="Search creators..." aria-label="Recipient's username" aria-describedby="button-addon2" style="border-radius: 18px; background-color: transparent; padding-left: 50px; padding-right: 50px; " v-model="search">

                                    <!-- <button v-if="search != ''" @click="closeSearch" class="btn btn-icon-only  btn-outline-dark">
                                        <i  class="hp-text-color-dark-0 ri-close-fill" style="font-size: 16px; cursor: pointer;  " ></i>
                                    </button> -->

                                    <i v-if="search != ''" class="hp-text-color-dark-0 ri-close-fill" style="font-size: 16px; cursor: pointer; margin-left: -35px; " @click="closeSearch"></i>
                                        
                                </div>
                            </div>

                            <div class="col-12 col-xl-8" style="z-index: 9; padding-bottom: 1000px; position: relative;">

                                <!-- <h2 class="mm-none" ></h2> -->
                                <h2 class="dd-none" style="margin-top: -30px;"></h2>

                                <!-- TABS -->
                                <div style="display: flex; justify-content: space-between; align-items: center;">

                                    <ul class="nav nav-tabs mb-12" id="myTab" role="tablist" style="overflow-x:auto;
                                flex-wrap:nowrap; scrollbar-width: none; ">
                                        <li class="nav-item" role="presentation" >
                                            <h6  class="nav-link active" id="all-tab" data-bs-toggle="tab" data-bs-target="#all"  role="tab" aria-controls="all" aria-selected="true" style="cursor: pointer; padding-bottom: 10px; ">All</h6>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <h6 class="nav-link" id="featured-tab" data-bs-toggle="tab" data-bs-target="#featured"  role="tab" aria-controls="featured" aria-selected="false" style="cursor: pointer; padding-bottom: 10px;">Featured</h6>
                                        </li>
                                                
                                        
                                        
                                        <li class="nav-item" role="presentation">
                                            <h6 class="nav-link" id="popular-tab" data-bs-toggle="tab" data-bs-target="#popular"  role="tab" aria-controls="popular" aria-selected="false" style="cursor: pointer; padding-bottom: 10px ;">Popular</h6>
                                        </li>

                                        <li class="nav-item" role="presentation">
                                            <h6 class="nav-link" id="new-tab" data-bs-toggle="tab" data-bs-target="#new"  role="tab" aria-controls="new" aria-selected="false" style="cursor: pointer; padding-bottom: 10px;">New</h6>
                                        </li>

                                        

                                    
                                    </ul>

                                    <div class="mm-none" style="position: relative;">

                                        <div style="width: 350px; display: flex; justify-content: center; align-items: center; margin-top: -15px;">

                                            <i class="hp-text-color-dark-0 iconly-Light-Search" style="font-size: 16px; margin-right: -35px; color: #b2bec3;"></i>

                                            <input @input="clearSearch" v-model="search" type="text" class="form-control" placeholder="Search creators..." aria-label="Recipient's username" aria-describedby="button-addon2" style="border-radius: 18px; background-color: transparent; padding-left: 50px; padding-right: 50px;">

                                            <i v-if="search != ''" class="hp-text-color-dark-0 ri-close-fill" style="font-size: 16px; cursor: pointer; position: absolute; right: 30px;" @click="closeSearch"></i>
                                        
                                        </div>

                                        

                                    </div>

                                </div>

                                

                                <!-- TAB CONTENT -->
                                <div  class="tab-content" id="allTabContent">
                                    <!-- ALL -->
                                    <div class="tab-pane fade show active" id="all" role="tabpanel" aria-labelledby="all-tab">

                                        <div class="col-12">

                                            <div class="row g-6">

                                                <!-- dupli -->
                                                <div class="col-12 col-xl-6" v-for="all in allList" :key="all.id">

                                                    <div class="card hp-card-1"
                                                        style="  padding: 0; margin: 0; border-radius: 10px; cursor: pointer; position: relative; overflow: hidden;" @click="profileClick(all.userId, all.userName)">

                                                        <img :src="all.profileBackground" alt=""
                                                            style="z-index: 2; object-fit: cover; position: absolute; top: 0; bottom: 0; border-radius: 10px; width: 100%; height: 100%;">

                                                        <div class="card-body card-overlay2" style="border-radius: 10px; z-index: 2;">
                                                            <div class="row ">

                                                                <div class="col">

                                                                    <div class="row align-items-center">
                                                                        <div class="w-auto px-0">
                                                                            <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                                style="width: 58px; height: 58px; ">
                                                                                <img :src="all.profilePic" class="hp-img-cover"
                                                                                    style="width: 58px; height: 58px; background-color: black; object-fit: cover; border-width: 0.5px; border-style: solid; border-color: #fff;">
                                                                            </div>
                                                                        </div>

                                                                        <div class="w-auto ms-8 px-0 mt-12">
                                                                            
                                                                            <div style="display: flex; justify-content: center; align-items: center;">

                                                                                <span
                                                                                    class="d-block hp-text-color-black-0 hp-text-color-dark-0 hp-p1-body lh-1"
                                                                                    style="font-size: 14px; max-width: 150px; font-weight: 500; font-family: 'Clash Display', sans-serif; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; text-align: start;"> {{ all.fullName }} </span>

                                                                                <span v-if="all.userType == 'model'">
                                                                                    <img src="@/assets/img/check-circle.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>
                                                                                
                                                                                <span v-if="all.sexuality == 'gay'">
                                                                                    <img src="@/assets/img/gay.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>

                                                                                <span v-else-if="all.sexuality == 'lesbian'">
                                                                                    <img src="@/assets/img/lesibian.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>

                                                                                <span v-else-if="all.sexuality == 'bisexual'">
                                                                                    <img src="@/assets/img/bisexual.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>

                                                                            </div>

                                                                            <p style="font-size: 12px; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; max-width: 150px;"
                                                                                class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4"> {{ all.userName }} </p>

                                                                        </div>

                                                                    </div>

                                                                    <div class="divider mt-18 mb-16" style="background-color: #838383;"></div>

                                                                    <div style="justify-content: space-between; display: flex; align-items: center;">

                                                                        <div style="display: flex; justify-content: center; align-items: center;">

                                                                            <i class="hp-text-color-dark-0  ri-image-2-line" style="color: #ffffff; font-size: 17px;"></i>
                                                                            <p class="hp-badge-text mb-0" style="color: #ffffff; margin-left: 5px; ">{{ all.postCount }}</p>

                                                                        </div>

                                                                        <div style="display: flex; justify-content: center; align-items: center;">

                                                                            <i class="hp-text-color-dark-0  ri-heart-line" style="color: #ffffff; font-size: 17px;"></i>
                                                                            <p class="hp-badge-text mb-0" style="color: #ffffff; margin-left: 5px; ">{{ all.likes }}</p>

                                                                        </div>

                                                                        <div style="display: flex; justify-content: center; align-items: center;">

                                                                            <i class="hp-text-color-dark-0 ri-user-star-line" style="color: #ffffff; font-size: 17px;"></i>
                                                                            <p class="hp-badge-text mb-0" style="color: #ffffff; margin-left: 5px; ">{{ all.fanCount }}</p>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            

                                                        </div>

                                                    </div>

                                                </div>

                                                <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyAll2">

                                                    <InfiniteLoading @infinite="handleInfinite" class="spinner">
                                                        
                                                    </InfiniteLoading>

                                                </div>

                                                <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;" id="emptyAll">
                                                    <p class="hp-badge-text">No creators yet...</p>
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                    <!-- featured -->
                                    <div class="tab-pane fade" id="featured" role="tabpanel" aria-labelledby="featured-tab">
                                        
                                        <div class="col-12">

                                            <div class="row g-6">

                                                <!-- dupli -->
                                                <div class="col-12 col-xl-6" v-for="popular in featuredList" :key="popular.id">

                                                    <div class="card hp-card-1"
                                                        style="  padding: 0; margin: 0; border-radius: 10px; cursor: pointer; position: relative; overflow: hidden;" @click="profileClick(popular.userId, popular.userName)">

                                                        <img :src="popular.profileBackground" alt=""
                                                            style="z-index: 2; object-fit: cover; position: absolute; top: 0; bottom: 0; border-radius: 10px; width: 100%; height: 100%; ">

                                                        <div class="card-body card-overlay2" style="border-radius: 10px; z-index: 2;">
                                                            <div class="row ">

                                                                <div class="col">

                                                                    <div class="row align-items-center">
                                                                        <div class="w-auto px-0">
                                                                            <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                                style="width: 58px; height: 58px; ">
                                                                                <img :src="popular.profilePic" class="hp-img-cover"
                                                                                    style="width: 58px; height: 58px; background-color: black; object-fit: cover; border-width: 0.5px; border-style: solid; border-color: #fff;">
                                                                            </div>
                                                                        </div>

                                                                        <div class="w-auto ms-8 px-0 mt-12">
                                                                            
                                                                            <div style="display: flex; justify-content: center; align-items: center;">

                                                                                <span
                                                                                    class="d-block hp-text-color-black-0 hp-text-color-dark-0 hp-p1-body lh-1"
                                                                                    style="font-size: 14px; max-width: 150px; font-weight: 500; font-family: 'Clash Display', sans-serif; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; text-align: start;"> {{ popular.fullName }} </span>

                                                                                <span v-if="popular.userType == 'model'">
                                                                                    <img src="@/assets/img/check-circle.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>
                                                                                
                                                                                <span v-if="popular.sexuality == 'gay'">
                                                                                    <img src="@/assets/img/gay.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>

                                                                                <span v-else-if="popular.sexuality == 'lesbian'">
                                                                                    <img src="@/assets/img/lesibian.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>

                                                                                <span v-else-if="popular.sexuality == 'bisexual'">
                                                                                    <img src="@/assets/img/bisexual.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>

                                                                            </div>

                                                                            <p style="font-size: 12px; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; max-width: 150px;"
                                                                                class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4"> {{ popular.userName }} </p>

                                                                        </div>


                                                                    </div>

                                                                    <div class="divider mt-18 mb-16" style="background-color: #838383;"></div>

                                                                    <div style="justify-content: space-between; display: flex; align-items: center;">

                                                                        <div style="display: flex; justify-content: center; align-items: center;">

                                                                            <i class="hp-text-color-dark-0  ri-image-2-line" style="color: #ffffff; font-size: 17px;"></i>
                                                                            <p class="hp-badge-text mb-0" style="color: #ffffff; margin-left: 5px; ">{{ popular.postCount }}</p>

                                                                        </div>

                                                                        <div style="display: flex; justify-content: center; align-items: center;">

                                                                            <i class="hp-text-color-dark-0  ri-heart-line" style="color: #ffffff; font-size: 17px;"></i>
                                                                            <p class="hp-badge-text mb-0" style="color: #ffffff; margin-left: 5px; ">{{ popular.likes }}</p>

                                                                        </div>

                                                                        <div style="display: flex; justify-content: center; align-items: center;">

                                                                            <i class="hp-text-color-dark-0 ri-user-star-line" style="color: #ffffff; font-size: 17px;"></i>
                                                                            <p class="hp-badge-text mb-0" style="color: #ffffff; margin-left: 5px; ">{{ popular.fanCount }}</p>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                        

                                    </div>

                                    <!-- popular -->
                                    <div class="tab-pane fade" id="popular" role="tabpanel" aria-labelledby="popular-tab">
                                        
                                        <div class="col-12">

                                            <div class="row g-6">

                                                <!-- dupli -->
                                                <div class="col-12 col-xl-6" v-for="popular in popularList" :key="popular.id">

                                                    <div class="card hp-card-1"
                                                        style="  padding: 0; margin: 0; border-radius: 10px; cursor: pointer; position: relative; overflow: hidden;" @click="profileClick(popular.userId, popular.userName)">

                                                        <img :src="popular.profileBackground" alt=""
                                                            style="z-index: 2; object-fit: cover; position: absolute; top: 0; bottom: 0; border-radius: 10px; width: 100%; height: 100%;">

                                                        <div class="card-body card-overlay2" style="border-radius: 10px; z-index: 2;">
                                                            <div class="row ">

                                                                <div class="col">

                                                                    <div class="row align-items-center">
                                                                        <div class="w-auto px-0">
                                                                            <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                                style="width: 58px; height: 58px; ">
                                                                                <img :src="popular.profilePic" class="hp-img-cover"
                                                                                    style="width: 58px; height: 58px; background-color: black; object-fit: cover; border-width: 0.5px; border-style: solid; border-color: #fff;">
                                                                            </div>
                                                                        </div>

                                                                        <div class="w-auto ms-8 px-0 mt-12">
                                                                            
                                                                            <div style="display: flex; justify-content: center; align-items: center;">

                                                                                <span
                                                                                    class="d-block hp-text-color-black-0 hp-text-color-dark-0 hp-p1-body lh-1"
                                                                                    style="font-size: 14px; max-width: 150px; font-weight: 500; font-family: 'Clash Display', sans-serif; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; text-align: start;"> {{ popular.fullName }} </span>

                                                                                <span v-if="popular.userType == 'model'">
                                                                                    <img src="@/assets/img/check-circle.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>
                                                                                
                                                                                <span v-if="popular.sexuality == 'gay'">
                                                                                    <img src="@/assets/img/gay.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>

                                                                                <span v-else-if="popular.sexuality == 'lesbian'">
                                                                                    <img src="@/assets/img/lesibian.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>

                                                                                <span v-else-if="popular.sexuality == 'bisexual'">
                                                                                    <img src="@/assets/img/bisexual.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>

                                                                            </div>

                                                                            <p style="font-size: 12px; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; max-width: 150px;"
                                                                                class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4"> {{ popular.userName }} </p>

                                                                        </div>


                                                                    </div>

                                                                    <div class="divider mt-18 mb-16" style="background-color: #838383;"></div>

                                                                    <div style="justify-content: space-between; display: flex; align-items: center;">

                                                                        <div style="display: flex; justify-content: center; align-items: center;">

                                                                            <i class="hp-text-color-dark-0  ri-image-2-line" style="color: #ffffff; font-size: 17px;"></i>
                                                                            <p class="hp-badge-text mb-0" style="color: #ffffff; margin-left: 5px; ">{{ popular.postCount }}</p>

                                                                        </div>

                                                                        <div style="display: flex; justify-content: center; align-items: center;">

                                                                            <i class="hp-text-color-dark-0  ri-heart-line" style="color: #ffffff; font-size: 17px;"></i>
                                                                            <p class="hp-badge-text mb-0" style="color: #ffffff; margin-left: 5px; ">{{ popular.likes }}</p>

                                                                        </div>

                                                                        <div style="display: flex; justify-content: center; align-items: center;">

                                                                            <i class="hp-text-color-dark-0 ri-user-star-line" style="color: #ffffff; font-size: 17px;"></i>
                                                                            <p class="hp-badge-text mb-0" style="color: #ffffff; margin-left: 5px; ">{{ popular.fanCount }}</p>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            

                                                        </div>

                                                    </div>

                                                </div>

                                                <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyPopular2">

                                                    <InfiniteLoading @infinite="handleInfinite2" class="spinner">
                                                        
                                                    </InfiniteLoading>

                                                </div>

                                                <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;" id="emptyPopular">
                                                    <p class="hp-badge-text">No creators yet...</p>
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                    <!-- new -->
                                    <div class="tab-pane fade" id="new" role="tabpanel" aria-labelledby="new-tab">
                                        
                                        <div class="col-12">

                                            <div class="row g-6">

                                                <!-- dupli -->
                                                <div class="col-12 col-xl-6" v-for="popular in newList" :key="popular.id">

                                                    <div class="card hp-card-1"
                                                        style="  padding: 0; margin: 0; border-radius: 10px; cursor: pointer; position: relative; overflow: hidden;" @click="profileClick(popular.userId, popular.userName)">

                                                        <img :src="popular.profileBackground" alt=""
                                                            style="z-index: 2; object-fit: cover; position: absolute; top: 0; bottom: 0; border-radius: 10px; width: 100%; height: 100%;">

                                                        <div class="card-body card-overlay2" style="border-radius: 10px; z-index: 2;">
                                                            <div class="row ">

                                                                <div class="col">

                                                                    <div class="row align-items-center">
                                                                        <div class="w-auto px-0">
                                                                            <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                                style="width: 58px; height: 58px; ">
                                                                                <img :src="popular.profilePic" class="hp-img-cover"
                                                                                    style="width: 58px; height: 58px; background-color: black; object-fit: cover; border-width: 0.5px; border-style: solid; border-color: #fff;">
                                                                            </div>
                                                                        </div>

                                                                        <div class="w-auto ms-8 px-0 mt-12">
                                                                            
                                                                            <div style="display: flex; justify-content: center; align-items: center;">

                                                                                <span
                                                                                    class="d-block hp-text-color-black-0 hp-text-color-dark-0 hp-p1-body lh-1"
                                                                                    style="font-size: 14px; max-width: 150px; font-weight: 500; font-family: 'Clash Display', sans-serif; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; text-align: start;"> {{ popular.fullName }} </span>

                                                                                <span v-if="popular.userType == 'model'">
                                                                                    <img src="@/assets/img/check-circle.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>
                                                                                
                                                                                <span v-if="popular.sexuality == 'gay'">
                                                                                    <img src="@/assets/img/gay.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>

                                                                                <span v-else-if="popular.sexuality == 'lesbian'">
                                                                                    <img src="@/assets/img/lesibian.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>

                                                                                <span v-else-if="popular.sexuality == 'bisexual'">
                                                                                    <img src="@/assets/img/bisexual.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                                                </span>

                                                                            </div>

                                                                            <p style="font-size: 12px; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; max-width: 150px;"
                                                                                class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4"> {{ popular.userName }} </p>

                                                                        </div>


                                                                    </div>

                                                                    <div class="divider mt-18 mb-16" style="background-color: #838383;"></div>

                                                                    <div style="justify-content: space-between; display: flex; align-items: center;">

                                                                        <div style="display: flex; justify-content: center; align-items: center;">

                                                                            <i class="hp-text-color-dark-0  ri-image-2-line" style="color: #ffffff; font-size: 17px;"></i>
                                                                            <p class="hp-badge-text mb-0" style="color: #ffffff; margin-left: 5px; ">{{ popular.postCount }}</p>

                                                                        </div>

                                                                        <div style="display: flex; justify-content: center; align-items: center;">

                                                                            <i class="hp-text-color-dark-0  ri-heart-line" style="color: #ffffff; font-size: 17px;"></i>
                                                                            <p class="hp-badge-text mb-0" style="color: #ffffff; margin-left: 5px; ">{{ popular.likes }}</p>

                                                                        </div>

                                                                        <div style="display: flex; justify-content: center; align-items: center;">

                                                                            <i class="hp-text-color-dark-0 ri-user-star-line" style="color: #ffffff; font-size: 17px;"></i>
                                                                            <p class="hp-badge-text mb-0" style="color: #ffffff; margin-left: 5px; ">{{ popular.fanCount }}</p>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            

                                                        </div>

                                                    </div>

                                                </div>

                                                <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyNew2">

                                                    <InfiniteLoading @infinite="handleInfinite3" class="spinner">
                                                        
                                                    </InfiniteLoading>

                                                </div>

                                                <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;" id="emptyNew">
                                                    <p class="hp-badge-text">No new creators this month...</p>
                                                </div>

                                            </div>

                                        </div>

                                    </div>


                                </div>

                                <!-- SEARCH -->
                                <div v-if="search != ''" class="card hp-card-6 sCard" id="searchDiv">

                                    <div class="card-body" style="border-radius: 10px;">

                                        <div @click="profileClick(srh.userId, srh.userName)" class="col-12" style="cursor: pointer;" v-for="srh in searchList" :key="srh.id">

                                            <div class="row align-items-center">
                                                <div class="w-auto px-0">
                                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 48px; height: 48px; ">
                                                        <img :src="srh.profilePic" class="hp-img-cover" style="width: 48px; height: 48px; background-color: black; object-fit: cover; border-width: 0.5px; border-style: solid; border-color: #fff;">
                                                    </div>
                                                </div>

                                                <div class="w-auto ms-8 px-0 mt-12">
                                                                            
                                                    <div style="display: flex; justify-content: center; align-items: center;">

                                                        <span class="d-block hp-text-color-black-30 hp-text-color-dark-0 hp-p1-body lh-1" style="font-size: 13px; max-width: 200px; font-weight: 500; font-family: 'Clash Display', sans-serif; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; text-align: start;"> {{ srh.fullName }} </span>

                                                        <span v-if="srh.userType == 'model'">
                                                            <img src="@/assets/img/check-circle.png" alt="" style="width: 12px; height: 12px; margin-left: 5px;">
                                                        </span>
                                                                                
                                                        <span v-if="srh.sexuality == 'gay'">
                                                            <img src="@/assets/img/gay.png" alt="" style="width: 12px; height: 12px; margin-left: 5px;">
                                                        </span>

                                                        <span v-else-if="srh.sexuality == 'lesbian'">
                                                            <img src="@/assets/img/lesibian.png" alt="" style="width: 12px; height: 12px; margin-left: 5px;">
                                                        </span>

                                                        <span v-else-if="srh.sexuality == 'bisexual'">
                                                            <img src="@/assets/img/bisexual.png" alt="" style="width: 12px; height: 12px; margin-left: 5px;">
                                                        </span>

                                                        

                                                    </div>

                                                    <p style="font-size: 12px;  text-overflow: ellipsis; white-space: nowrap;overflow: hidden; max-width: 200px;" class="hp-badge-text fw-normal hp-text-color-dark-30 mt-0"> @{{ srh.userName }} </p>

                                                </div>

                                            </div>

                                            <div class="divider mt-18 mb-16" ></div>

                                        </div>

                                        <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptySearch2">

                                            <InfiniteLoading @infinite="handleInfinite4" class="spinner">
                                            </InfiniteLoading>

                                        </div>

                                        <div v-if="searchList.length == 0" style="margin-top: 100px; margin-bottom: 100px; display: none; justify-content: center; align-items: center; flex-direction: column; " id="emptySearch">
                                            <p class="hp-badge-text">No results for @{{ search }}</p>
                                        </div>

                                    </div>

                                </div>

                            </div>

                            

                            <!-- SUGGESTIONS -->
                            <div class="col-12 col-xl-4 ">

                                

                                <SpotlightBody/>

                            </div>
                            

                        </div>

                    </div>

                    
                </div>

                 <!-- FOOTER -->
                <FooterBody/>

            </div>

        </div>


    </main>

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- SEARCH -->
        


    
</template>

<style scoped>
    .card-overlay2 {
        background: rgba(0, 0, 0, 0.6);
        border-radius: 20px;
    }

    .sCard{
        position: absolute; 
        z-index: 99; 
        width: 350px; 
        border-radius: 10px; 
        top: 38px; 
        right: 25px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.29);
        overflow-y: scroll;
        max-height: 500px;
        overscroll-behavior: contain !important;

    }

    .card-overlay4{

        background: rgba(255, 255, 255, 0.2);
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 20px;

    }

    @media only screen and (max-width: 666px){

        .sCard{
            position: absolute; 
            z-index: 99; 
            width: 350px; 
            border-radius: 10px; 
            top: -30px; 
            right: 25px;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.29);
            overflow-y: scroll;
            max-height: 500px;
            overscroll-behavior: contain !important;

        }

    }

</style>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import SpotlightBody from './SpotlightBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
    import "../../node_modules/v3-infinite-loading/lib/style.css";

    import TimeAgo from 'javascript-time-ago';
    import en from 'javascript-time-ago/locale/en';

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, serverTimestamp, orderBy, limit, startAfter, Timestamp } from "firebase/firestore"; 
    import {getAuth} from "firebase/auth"
    import { db } from '@/firebase';

    export default {

        components: {
            SidebarBody,
            HeaderBody,
            SpotlightBody,
            FooterBody,
            InfiniteLoading,
        },

        data(){
            return{
                loadingText:"",
                errorText: "",
                successText: "",

                search: "",
                

                lastDocSnapshot: null,
                lastDocSnapshot2: null,
                lastDocSnapshot3: null,
                lastDocSnapshot4: null,
                lastDocSnapshot5: null,
                lastDocSnapshot6: null,
                lastDocSnapshot7: null,

                allList: [],
                featuredList: [],
                newList: [],
                popularList: [],
                searchList: [],
                
            }
        },

        mounted(){

            
            document.body.style.overflowY = 'scroll';
            document.body.style.overflowX = 'hidden';

            document.getElementById("mobileLogo").style.display= 'none';
            document.getElementById("mobileTitle").textContent = 'Explore';

            
            document.getElementById("exploreN").classList.add("active");
            
            document.getElementById("exploreN2").classList.add("active");

            this.getFeatured();
            //this.clickOut();
            
        },

        methods:{

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            hasMultiple(arr, key) {
                return arr.some((item, index) => 
                    arr.findIndex(obj => obj[key] === item[key]) !== index
                );
            },

            closeSearch(){
                this.search = "";
                this.searchList = [];
                this.lastDocSnapshot4 = null;
            },

            async clearSearch(){

                if(this.search.length != ""){

                    this.lastDocSnapshot4 = null;
                    this.searchList = []; 
                    this.getSearch();
                
                }
                
                
                
            },

            delay(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },

            clickOut(){

                let myDiv = document.getElementById("searchDiv");

                document.addEventListener('click', (event) => {

                    if ( event.target !== myDiv) {
                        // Click occurred outside the div
                        this.search = "";
                    }
                });
            },

            kFormatter(num) {
                return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num);
                
            },

            profileClick(userId, userName) {

                const auth = getAuth();

                if (auth.currentUser.uid == userId) {
                    this.$router.push({ name: 'profile' });
                    return;
                }

                sessionStorage.setItem("otherId", userId);
                this.$router.push({ name: 'other-profile', params: { id: userName } });
                return;

            },

            async getAll(){

                let res = [];
                const q = query(collection(db, "Users"), where("type", '==', "model"), orderBy("name"), limit(15), startAfter(this.lastDocSnapshot || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let result = {
                            id: doc.id,
                            userId: doc.data().userId,
                            fullName: doc.data().name,
                            userName: doc.data().displayId, 
                            profilePic: doc.data().profilePic,
                            profileBackground: doc.data().profileBackground,
                            
                            sexuality: doc.data().sexuality,
                            postCount: this.kFormatter(doc.data().postCount),
                            likes: this.kFormatter(doc.data().likes),
                            fanCount: this.kFormatter(doc.data().fanCount),
                            dateJoined: doc.data().dataJoined,
                            userType: doc.data().type

                        }

                        this.allList.push(result);
                        

                    })
                    
                }

                return res.length;

            },

            async getPopular(){

                let res = [];
                const q = query(collection(db, "Users"), where("type", '==', "model"), orderBy("fanCountN"), limit(15), startAfter(this.lastDocSnapshot2 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot2 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let result = {
                            id: doc.id,
                            userId: doc.data().userId,
                            fullName: doc.data().name,
                            userName: doc.data().displayId, 
                            profilePic: doc.data().profilePic,
                            profileBackground: doc.data().profileBackground,
                            
                            sexuality: doc.data().sexuality,
                            postCount: this.kFormatter(doc.data().postCount),
                            likes: this.kFormatter(doc.data().likes),
                            fanCount: this.kFormatter(doc.data().fanCount),
                            dateJoined: doc.data().dataJoined,
                            userType: doc.data().type

                        }

                        this.popularList.push(result);
                        

                    })
                    
                }

                return res.length;

            },

            async getFeatured(){

                let tempList;

                const adminRef = doc(db, "AdminInfo", "info");
                const adminSnap = await getDoc(adminRef);

                if(adminSnap.exists()){
                    tempList = adminSnap.data().featuredList
                }

                this.getFeatured2(tempList);

            },

            async getFeatured2(tempList){

                for(let i = 0; i < tempList.length; i++){

                    const userRef = doc(db, "Users", tempList[i]);
                    const userSnap = await getDoc(userRef);

                    if(userSnap.exists()){

                        this.featuredList.push({

                            id: userSnap.data().userId,
                            userId: userSnap.data().userId,
                            fullName: userSnap.data().name,
                            userName: userSnap.data().displayId, 
                            profilePic: userSnap.data().profilePic,
                            profileBackground: userSnap.data().profileBackground,
                                
                            sexuality: userSnap.data().sexuality,
                            postCount: this.kFormatter(userSnap.data().postCount),
                            likes: this.kFormatter(userSnap.data().likes),
                            fanCount: this.kFormatter(userSnap.data().fanCount),
                            dateJoined: userSnap.data().dataJoined,
                            userType: userSnap.data().type

                        })

                    }
                }

            },

            async getNew(){

                const thirtyDaysAgo = new Date();
                thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 50);

                const thirtyDaysAgoTimestamp = Timestamp.fromDate(thirtyDaysAgo);

                let res = [];
                const q = query(collection(db, "Users"), where("type", '==', "model"), where("dateJoined", '>', thirtyDaysAgoTimestamp), orderBy("dateJoinedN"), limit(15), startAfter(this.lastDocSnapshot3 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot3 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let result = {
                            id: doc.id,
                            userId: doc.data().userId,
                            fullName: doc.data().name,
                            userName: doc.data().displayId, 
                            profilePic: doc.data().profilePic,
                            profileBackground: doc.data().profileBackground,
                            
                            sexuality: doc.data().sexuality,
                            postCount: this.kFormatter(doc.data().postCount),
                            likes: this.kFormatter(doc.data().likes),
                            fanCount: this.kFormatter(doc.data().fanCount),
                            dateJoined: doc.data().dataJoined,
                            userType: doc.data().type

                        }

                        this.newList.push(result);
                        

                    })
                    
                }

                return res.length;

            },

            async getSearch(){

                let res = [];

                const q = query(collection(db, "Users"), where("type", '==', "model"), where("displayId", ">=" , this.search), where("displayId", "<" , this.search+"z") , orderBy("displayId"), limit(10), startAfter(this.lastDocSnapshot4 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot4 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let result = {
                            id: doc.id,
                            userId: doc.data().userId,
                            fullName: doc.data().name,
                            userName: doc.data().displayId, 
                            profilePic: doc.data().profilePic,
                            profileBackground: doc.data().profileBackground,
                            
                            sexuality: doc.data().sexuality,
                            postCount: this.kFormatter(doc.data().postCount),
                            likes: this.kFormatter(doc.data().likes),
                            fanCount: this.kFormatter(doc.data().fanCount),
                            dateJoined: doc.data().dateJoined,
                            userType: doc.data().type

                        }

                        this.searchList.push(result)

                        this.searchList = Array.from(new Set(this.searchList.map(a => a.id))) .map(id => {
                            return this.searchList.find(a => a.id === id)
                        })
                        
                        

                    })

                    
                    
                }

                return res.length;

            },

            async handleInfinite($state){

                const newPostCount = await this.getAll();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.allList.length == 0){
                        document.getElementById("emptyAll").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyAll2").style.display = "none";
                    return $state.complete();

                    

            },

            async handleInfinite2($state){

                const newPostCount = await this.getPopular();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.popularList.length == 0){
                        document.getElementById("emptyPopular").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyPopular2").style.display = "none";
                    return $state.complete();

                    

            },

            async handleInfinite3($state){

                const newPostCount = await this.getNew();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.newList.length == 0){
                        document.getElementById("emptyNew").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyNew2").style.display = "none";
                    return $state.complete();

            },

            async handleInfinite4($state){

                const newPostCount = await this.getSearch();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.searchList.length == 0){
                        document.getElementById("emptySearch").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptySearch2").style.display = "none";
                    return $state.complete();

            },


        }

        

    }
</script>